import React from 'react';
import { Content, Box } from 'reactjs-admin-lte';
import JobDraftListTable from './JobDraftListTable';


const JobDraftList = (props) => {
  
  const {
    jobs,
    isLoading,
    handleTabOpen
  } = props;
  
  return (
    <Content.Body>
      <Box
        className="box-widget mb-0"
        loading={isLoading}>
        <Box.Body noPadding={true}>
          <JobDraftListTable
            jobs={jobs}
            handleTabOpen={handleTabOpen} />
        </Box.Body>
      </Box>
    </Content.Body>
  );
}

export default JobDraftList;
